import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FileDown, FileWarning } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const LOGO = "https://content.webfactorysite.co.uk/20260113092111-Wales-Event-Logo.png?t=1768296071";

export default function ReportShare() {
  const { token } = useParams();
  const [meta, setMeta] = useState(null);
  const [err, setErr] = useState("");
  const pdfUrl = `${BACKEND}/api/public/report-share/${token}/pdf`;

  useEffect(() => {
    document.title = "Event Medical Report — Wales Event Medical Services";
    fetch(`${BACKEND}/api/public/report-share/${token}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("bad"))))
      .then(setMeta)
      .catch(() => setErr("This report link isn't valid any more."));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0F2547] flex flex-col" data-testid="report-share-page">
      <header className="px-4 sm:px-8 py-4 flex items-center justify-between gap-3 border-b border-white/10">
        <div className="flex items-center gap-3 min-w-0">
          <img src={LOGO} alt="Wales Event Medical Services" className="h-10 w-auto bg-white rounded-lg px-2 py-1" />
          <div className="min-w-0">
            <h1 className="text-white font-bold text-sm sm:text-base truncate" data-testid="report-share-title">
              {meta?.title || "Event Medical Report"}
            </h1>
            {meta?.event_label && <p className="text-slate-300 text-xs truncate" data-testid="report-share-event">{meta.event_label}</p>}
          </div>
        </div>
        <a href={pdfUrl} download data-testid="report-share-download"
          className="inline-flex items-center gap-2 bg-[#00A499] hover:bg-[#008f85] text-white text-sm font-bold px-4 py-2.5 rounded-lg transition-colors shrink-0">
          <FileDown className="h-4 w-4" /> Download PDF
        </a>
      </header>
      {err ? (
        <div className="flex-1 grid place-items-center p-8 text-center" data-testid="report-share-error">
          <div>
            <FileWarning className="h-10 w-10 text-slate-400 mx-auto mb-3" />
            <p className="text-slate-300 text-sm">{err}</p>
          </div>
        </div>
      ) : (
        <iframe src={pdfUrl} title="Event medical report PDF" data-testid="report-share-pdf"
          className="flex-1 w-full bg-white" style={{ minHeight: "82vh", border: 0 }} />
      )}
      <p className="text-center text-[11px] text-slate-400 py-3">Confidential — shared by Wales Event Medical Services</p>
    </div>
  );
}
